export const  baseURL = "http://localhost:5000/v1";
export const  baseSocketURL = "http://localhost:5000";
export const  imageUrl = "https://res.cloudinary.com/dkxfvwrhz/image/upload/c_pad,b_auto:predominant,fl_preserve_transparency/v1694583389/Avatar_k2bs4h.jpg?_s=public-apps";